import React from 'react'
import { graphql} from 'gatsby'

import Layout from "../components/layout"
import SEO from "../components/seo"
import BioDetail from "../components/bio-detail"
import InterventiProgramma from "../components/interventi-programma"
import Newsletter from "../components/newsletter"
import Banner from "../components/banner"


const Speaker = ({ pageContext: {title, locale}, data }) => (
    <Layout locale={locale}>
        <SEO title={title}/>
        {!!data.interventi &&
            <>
            <BioDetail speaker={data.speaker} intervento={data.interventi.edges.map(edge => edge.node)[0]}/>
            <InterventiProgramma interventi={data.interventi.edges.map(edge => edge.node)}/>
            </>
        }
        <Newsletter/>
        <Banner/>
    </Layout>
);

export const query = graphql`
    query SpeakerQuery($title: String!, $locale: String!) {
        speaker: speakerYaml(title: {eq: $title}, lang: {eq: $locale}){
            title
            jobtitle
            bio
            linkedin
            twitter
            website
            pubblicazioni
            img
            workshop
            casestudy
            keynote
        }  
        interventi: allInterventiYaml(filter: {relatore: {eq: $title}, lang: {eq: $locale}}){
            edges {
                node {
                    title
                    pageslug
                    orario
                    orariodesc
                    day
                    luogo
                    tipologia
                    abstract
                    description
                }
            }
        }
    }
`;

export default Speaker;
